const Team = () => {
  return (
    <div className="mt-16 md:mt-0 lg:mt-16 px-3 py-5 sm:grid sm:grid-cols-2 sm:items-center sm:gap-10">
      <div className="flex flex-col space-y-5">
        <h1 className="text-2xl font-bold font-mono lg:text-4xl">
          For teamwork of any size
        </h1>
        <p className="text-lg font-semibold">
          Slack supports collaboration at a global scale, with unlimited
          channels to mirror the way your company actually works.
        </p>
      </div>
      <div>
        <img src="/images/TeamsTwo.svg" alt="" />
      </div>
    </div>
  );
};

export default Team;
